/** Şablona özgü amblem: elmas, yörünge halkaları ve yarışma adı. Hiçbir TV programının logosunu taklit etmez. */
export function BillionaireEmblem({ className = '' }: { className?: string }) {
  return (
    <svg className={`billionaire-emblem ${className}`} viewBox="0 0 320 320" role="img" aria-label="Kim Milyarder Olmak İster? amblemi">
      <defs>
        <radialGradient id="bq-core" cx="50%" cy="42%" r="60%">
          <stop offset="0" stopColor="#2b5fbf" /><stop offset=".55" stopColor="#0b1a4c" /><stop offset="1" stopColor="#030819" />
        </radialGradient>
        <linearGradient id="bq-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff6c4" /><stop offset=".45" stopColor="#f2c14e" /><stop offset="1" stopColor="#a9731c" />
        </linearGradient>
        <linearGradient id="bq-cyan" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#2fd6ff" stopOpacity=".15" /><stop offset=".5" stopColor="#9ff0ff" /><stop offset="1" stopColor="#2fd6ff" stopOpacity=".15" />
        </linearGradient>
      </defs>
      <circle cx="160" cy="160" r="150" fill="url(#bq-core)" stroke="url(#bq-gold)" strokeWidth="5" />
      <g className="billionaire-emblem-rings" fill="none">
        <ellipse cx="160" cy="160" rx="132" ry="48" stroke="url(#bq-cyan)" strokeWidth="3" transform="rotate(-24 160 160)" />
        <ellipse cx="160" cy="160" rx="132" ry="48" stroke="url(#bq-cyan)" strokeWidth="3" transform="rotate(24 160 160)" />
        <ellipse cx="160" cy="160" rx="118" ry="118" stroke="#f2c14e" strokeOpacity=".35" strokeWidth="1.5" strokeDasharray="4 9" />
      </g>
      <g className="billionaire-emblem-diamond">
        <polygon points="160,58 214,112 160,196 106,112" fill="url(#bq-gold)" stroke="#fff4c0" strokeWidth="2" />
        <polygon points="160,58 182,112 160,196 138,112" fill="#fff8d6" fillOpacity=".38" />
        <line x1="106" y1="112" x2="214" y2="112" stroke="#fff4c0" strokeWidth="2" />
      </g>
      <path d="M40 214 H280 L266 238 L280 262 H40 L54 238 Z" fill="#050d2e" stroke="url(#bq-gold)" strokeWidth="3" />
      <text x="160" y="233" textAnchor="middle" className="billionaire-emblem-title">KİM MİLYARDER</text>
      <text x="160" y="254" textAnchor="middle" className="billionaire-emblem-subtitle">OLMAK İSTER?</text>
    </svg>
  );
}

export type BillionaireTransitionInfo = { kind: 'question' | 'bonus' | 'final'; title: string; subtitle: string };

/** Sorular arası 1,6 saniyelik logolu geçiş. Dokunarak veya tıklayarak atlanabilir. */
export function BillionaireTransition({ info, onSkip }: { info: BillionaireTransitionInfo; onSkip: () => void }) {
  return (
    <div className={`billionaire-transition ${info.kind}`} onClick={onSkip} role="status" aria-live="polite">
      <div className="billionaire-transition-beams" aria-hidden="true">{Array.from({ length: 6 }, (_, i) => <span key={i} />)}</div>
      <div className="billionaire-transition-emblem">
        <BillionaireEmblem />
        <span className="billionaire-transition-shine" aria-hidden="true" />
      </div>
      <h2>{info.title}</h2>
      <p>{info.subtitle}</p>
      <span className="billionaire-transition-brand"><img src="/odevlendir/assets/brand/tekk-logo.jpg" alt="" /> Tekte Öğren</span>
      <small className="billionaire-transition-skip">Geçmek için dokun</small>
    </div>
  );
}
